import { Logger } from "@stg-oneportal/logger"
import { useConfig } from "./useConfig"

export const useLogger = (prefix: string) => {
  const config = useConfig()

  return new Logger(prefix, config.logger.enabled)
}
